var PrivacyStatementComponent = /** @class */ (function () {
    function PrivacyStatementComponent() {
    }
    return PrivacyStatementComponent;
}());
export { PrivacyStatementComponent };
